/** @description Позиция счетчика слайдов
 * ECounterPosition.HEADER В шапке
 */
export var ECounterPosition;

/** @description Слайды для карусели
 * @param {React.ReactNode} node Содержимое слайда
 * @param {string} key Уникальный ключ
 * @param {string} key Уникальный ключ
 */
(function (ECounterPosition) {
  ECounterPosition[ECounterPosition["HEADER"] = 0] = "HEADER";
})(ECounterPosition || (ECounterPosition = {}));